// extracted by mini-css-extract-plugin
export default {"card":"BioCard_card__Rnw0i","rating":"BioCard_rating__5FMca","title":"BioCard_title__SrfRm","action":"BioCard_action__+pkic","footer":"BioCard_footer__3Haqe"};